import type { AnchorHTMLAttributes } from 'react';

// SDK stand-in for next/link. Partner pages have no Next router, so a Link is a
// plain anchor; the real next/link pulled 100 router modules (147 KB) into the
// bundle. Swapped in by the sdk-shims plugin in rollup.react.config.js.
export default function Link({
  href,
  children,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }) {
  return (
    <a href={href} {...rest}>
      {children}
    </a>
  );
}
